<template>
    <!-- Scelta del pacchetto Target Training (#212). Non compare se l'elenco è vuoto (iniziativa spenta). -->
    <div v-if="packs.length" class="target-pack-picker mt-2" role="radiogroup" aria-label="Pacchetto Target Training">
        <label class="form-label">Scegli il pacchetto</label>
        <div class="form-check d-flex justify-content-between">
            <span>
                <input class="form-check-input" type="radio" id="target-pack-single" name="target-pack"
                    :checked="!modelValue" @change="$emit('update:modelValue', null)" />
                <label class="form-check-label" for="target-pack-single">Singolo programma</label>
            </span>
            <span class="highlight">{{ formatPrice(singlePrice) }}€</span>
        </div>
        <div v-for="p in packs" :key="p.code" class="form-check d-flex justify-content-between">
            <span>
                <input class="form-check-input" type="radio" :id="'target-pack-' + p.code" name="target-pack"
                    :checked="modelValue === p.code" @change="$emit('update:modelValue', p.code)" />
                <label class="form-check-label" :for="'target-pack-' + p.code">{{ p.label }}</label>
            </span>
            <span class="highlight">{{ formatPrice(p.price) }}€</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TargetPackPicker',
    props: {
        packs: { type: Array, default: () => [] },
        modelValue: { type: String, default: null },
        singlePrice: { type: Number, default: 0 },
    },
    emits: ['update:modelValue'],
    methods: {
        formatPrice(v) { return Number(v || 0).toFixed(2); },
    },
};
</script>

<style scoped>
.target-pack-picker { overflow-wrap: anywhere; }
</style>
